var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#C4E3B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5922 6.00822C15.5147 5.93011 15.4226 5.86811 15.321 5.82581C15.2195 5.7835 15.1105 5.76172 15.0005 5.76172C14.8905 5.76172 14.7816 5.7835 14.68 5.82581C14.5785 5.86811 14.4863 5.93011 14.4089 6.00822L8.20053 12.2249L5.59219 9.60822C5.51176 9.53052 5.41681 9.46942 5.31276 9.42842C5.20872 9.38742 5.09761 9.36731 4.9858 9.36924C4.87398 9.37118 4.76364 9.39512 4.66107 9.4397C4.55851 9.48427 4.46573 9.54862 4.38803 9.62905C4.31033 9.70949 4.24923 9.80444 4.20823 9.90848C4.16723 10.0125 4.14712 10.1236 4.14905 10.2354C4.15099 10.3473 4.17493 10.4576 4.21951 10.5602C4.26408 10.6627 4.32843 10.7555 4.40886 10.8332L7.60886 14.0332C7.68633 14.1113 7.7785 14.1733 7.88005 14.2156C7.9816 14.2579 8.09052 14.2797 8.20053 14.2797C8.31054 14.2797 8.41946 14.2579 8.52101 14.2156C8.62256 14.1733 8.71473 14.1113 8.79219 14.0332L15.5922 7.23322C15.6768 7.15518 15.7443 7.06047 15.7905 6.95506C15.8366 6.84964 15.8605 6.7358 15.8605 6.62072C15.8605 6.50563 15.8366 6.3918 15.7905 6.28638C15.7443 6.18096 15.6768 6.08625 15.5922 6.00822Z",
    fill: "#4CAF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadCheck);
export default __webpack_public_path__ + "static/media/read_check.062e5e31048143c7eba971728c12ffd4.svg";
export { ForwardRef as ReactComponent };